import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { Preset } from '@primeng/themes/types';

import { baseTheme } from '../shared/base-theme';

/** Texas Show Pass (default org) — navy / blue primary ramp. */
export const TxShowPassPreset: Preset<any> = definePreset(Material, {
  ...baseTheme,
  semantic: {
    ...baseTheme.semantic,
    primary: {
      50: '#f3f6fa',  // very light tint
      100: '#c4d6e8',
      200: '#95b5d6',
      300: '#6695c3',
      400: '#3774b1',
      500: '#08549f', // base
      600: '#074787', // darker
      700: '#063b6f',
      800: '#042e57',
      900: '#032240',
      950: '#021528'  // darkest
    }
  }
});
